import { render, staticRenderFns } from "./BindsField.vue?vue&type=template&id=70342944&"
import script from "./BindsField.vue?vue&type=script&lang=js&"
export * from "./BindsField.vue?vue&type=script&lang=js&"
import style0 from "./BindsField.vue?vue&type=style&index=0&id=70342944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports